import { Box, Button, styled, Typography } from "@mui/material"
import UIIcon from "../../../components/UIIcon"

export const ContentContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  flex: 1,
  rowGap: 20,
})

export const CenterContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  marginTop: 10,
  flexGrow: 1,
  justifyContent: "center",
})

export const Amount = styled(Typography)({
  marginTop: 10,
  fontWeight: "normal",
})

export const SourceDescription = styled(Typography)({
  width: 300,
  textAlign: "center",
  marginTop: 30,
})

export const RecipientContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  marginTop: 10,
})

export const StyledButton = styled(Button)({
  marginTop: 10,
  minHeight: 54,
  width: "100%",
})

export const SBPIcon = styled(UIIcon)({
  margin: "auto auto 0 auto",
})

export const ButtonTransfer = {
  display: "flex",
  flexDirection: "column",
}
